import "./matchRules.sass";

export default function MatchRules() {
  return (
    <div className="MatchRules">
      <h3>Descripción Simulador</h3>

      <ul>
        <li>SIMULAR TODO: Genera por completo el sorteo de toda la fase de grupos en un solo clic.</li>
        <li>FASE DE GRUPOS: Te ayuda a regresar a los grupos una vez que te mueves entre Eliminatorias y Fase de Grupos.</li>
        <li>ELIMINATORIAS: El botón para avanzar a la siguiente ronda una vez que resuelves la fase de grupos.</li>
        <li>REINICIAR: Regenera por completo y desde cero todo el simulador.</li>
        <li>SIMULAR GRUPO: Te permite generar en automático todos los resultados de cada grupo con un solo clic.</li>
      </ul>
    </div>
  );
}